import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import type { ResourceLanguage } from "i18next";

// Todos os namespaces são carregados automaticamente de src/i18n/<locale>/*.json.
// Criar o par de arquivos (pt-BR + en-US) registra o namespace — sem passo manual aqui.
// O teste de paridade (parity.test.ts) garante que os dois locales têm as mesmas chaves.
const ptModules = import.meta.glob<Record<string, unknown>>(
  "../../i18n/pt-BR/*.json",
  { eager: true, import: "default" },
);
const enModules = import.meta.glob<Record<string, unknown>>(
  "../../i18n/en-US/*.json",
  { eager: true, import: "default" },
);

function toNamespaces(
  modules: Record<string, Record<string, unknown>>,
): ResourceLanguage {
  return Object.fromEntries(
    Object.entries(modules).map(([path, resource]) => [
      path.replace(/^.*\/([^/]+)\.json$/, "$1"),
      resource,
    ]),
  );
}

const ptResources = toNamespaces(ptModules);
const enResources = toNamespaces(enModules);

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "en-US"],
    ns: Object.keys(ptResources),
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["cookie", "navigator", "htmlTag"],
      caches: ["cookie"],
      lookupCookie: "imobgo.locale",
      cookieMinutes: 60 * 24 * 365,
    },
    resources: {
      "pt-BR": ptResources,
      "en-US": enResources,
    },
    react: { useSuspense: false },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.resolvedLanguage ?? "pt-BR";

export default i18n;
